import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { IconsName } from '../svg-icon';

export enum BannerSize {
  XS = 'xs',
  MD = 'medium',
  LG = 'large'
}

export enum BannerDisplayType {
  LIFESTYLE = 'LIFESTYLE',
  PRODUCT = 'PRODUCT'
}

@Component({
  selector: 'shrd-uic-master-banner',
  templateUrl: './master-banner.component.html',
  styleUrls: ['./master-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MasterBannerComponent implements OnInit {
  @Input() bannerSize: BannerSize;
  @Input() bannerHeadline: string;
  @Input() mobileHeadline: string;
  @Input() imageUrl: string;
  @Input() buttonText: string;
  @Input() buttonTarget: string;
  @Input() isLifestyle?: boolean;
  @Input() bannerOverline?: string;
  @Input() bannerSubline?: string;
  @Input() bannerBodyText?: string;

  readonly bannerSizeType = BannerSize;
  iconsSet = IconsName;

  ngOnInit(): void {
    this.bannerSize = this.bannerSize || BannerSize.MD;
  }
}
